import axios from 'axios';

import { API_ROOT } from './settings';

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const doProfileCall = (action, profileId, token) => {
  return axios({
    method: 'get',
    url: `${API_ROOT}/api/puma/doProfile/${action}/${profileId}/`,
    headers: { 'Authorization': `Token ${token}` }
  });
};

export const formatNumber = (int) => {
  return int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const openInNewTab = (e, url) => {
  e.preventDefault();
  var win = window.open(url);
  win.focus();
};

export const editorToolbarSettings = {
  options: ['inline', 'blockType', 'list', 'history', 'link'],
  inline: {
    inDropdown: false,
    options: ['bold', 'italic']
  },
  blockType: {
    inDropdown: false,
    options: ['Normal', 'H2', 'H3', 'H4', 'H5', 'H6']
  },
  list: {
    inDropdown: false,
    options: ['unordered', 'ordered']
  },
  history: {
    inDropdown: false
  },
  link: {
    inDropdown: false,
    options: ['link', 'unlink']
  }
};

export const getProviderDisplayName = profile => {
  if (profile.preferredMiddleName) {
    return `${profile.preferredFirstName} ${profile.preferredMiddleName} ${profile.preferredLastName}`;
  }
  return profile.preferredFirstName || profile.preferredLastName ? `${profile.preferredFirstName} ${profile.preferredLastName}` : profile.displayName;
}

export const validateRequiredFields = (required, refs) => {
  const message = 'Field must not be left blank';
  const emptyRequiredFields = required.filter(name => refs[name].value === '');
  const errors = emptyRequiredFields.map(name => ({ name, message }));
  return errors;
}

export const getMailToLink = (email, componentName='', subject='', message='') => {
  return `mailto:${email}?subject=PUMA${ componentName && ` - ${componentName}`}${ subject && ` - ${subject}`}${ message && `&body=${message}` }`
}

export const validateCharFieldErrors = (lengths, refs) => {
  const message = 'Field has too many characters.';
  const keys = Object.keys(lengths);
  const invalidCharField = keys.filter(key => lengths[key] < refs[key].value.length);
  const errors = invalidCharField.map(key => {
    let error = {};
    error.name = key;
    error.message = message;
    return error;
  });
  return errors
}


// WEBPACK FOOTER //
// ./src/utils.jsx